import { zIndex } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

import { invoicePreviewRibbonVariantStyles } from './constants/invoicePreviewRibbonVariantStyles'
import { InvoicePreviewRibbonVariant } from './types/invoicePreviewRibbonVariant'

const RIBBON_WRAPPER_OFFSET = '-7px'
const RIBBON_WRAPPER_MIN_HEIGHT = '150px'
// RIBBON_WIDTH - the width needed to contain the ribbon before rotating (45deg rotating decreases width by ~20%)
const RIBBON_WIDTH = '180px'
const RIBBON_TOP_OFFSET = '33px'
const RIBBON_LEFT_OFFSET = '-41px'
const RIBBON_ROTATION_DEGREE = '-45deg'

export const InvoicePreviewRibbonWrapper = styled.div`
  min-height: ${RIBBON_WRAPPER_MIN_HEIGHT};
  position: absolute;
  top: ${RIBBON_WRAPPER_OFFSET};
  left: ${RIBBON_WRAPPER_OFFSET};
  z-index: ${zIndex.CornerRibbon};
  overflow: hidden;
`
interface InvoicePreviewRibbonItemProps {
  variant: InvoicePreviewRibbonVariant
}

export const InvoicePreviewRibbonItem = styled.div<InvoicePreviewRibbonItemProps>`
  width: ${RIBBON_WIDTH};
  padding: 5px 0;
  position: relative;
  top: ${RIBBON_TOP_OFFSET};
  left: ${RIBBON_LEFT_OFFSET};
  transform: rotate(${RIBBON_ROTATION_DEGREE});
  background-color: ${({ variant }) => invoicePreviewRibbonVariantStyles[variant].bgColor};

  &:before,
  &:after {
    content: '';
    border-top: ${({ variant }) =>
      `5px solid ${transparentize(0.5, invoicePreviewRibbonVariantStyles[variant].bgColor)}`};
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
    position: absolute;
    bottom: -5px;
  }

  // left ribbon fold
  &:before {
    left: 8px;
  }

  // right ribbon fold
  &:after {
    right: 12px;
  }
`
